import { format } from 'date-fns'

export const formatDate = (date: string | number, useFormat: string) => {
  if (!date) return null
  return format(new Date(date), useFormat)
}
